import { apiClient } from "./client";

export interface MyWorkspace {
  id: string;
  name: string;
  role: "ADMIN" | "USER" | "VIEWER";
  active: boolean;
  estimatedDaysRemaining?: number;
  balanceUsd: number;
  /** Origin this workspace's tracking links are published on: its verified custom domain if it
   * has one, otherwise the shared platform domain. */
  trackingOrigin?: string;
}

/** One counter against its ceiling, for the "8 of 25 used" line above a list. */
export interface Usage {
  used: number;
  limit: number;
}

export interface WorkspaceUsage {
  landings: Usage;
  spots: Usage;
  domains: Usage;
  teamMembers: Usage;
  trackingLinks: Usage;
}

export const workspacesApi = {
  getMine: () => apiClient.get<MyWorkspace[]>("/workspaces/mine"),
  getUsage: () => apiClient.get<WorkspaceUsage>("/workspaces/usage"),
  switchTo: (workspaceId: string) =>
    apiClient.post<MyWorkspace[]>("/workspaces/switch", { workspaceId }),
};
